import axios, { InternalAxiosRequestConfig } from 'axios';
import { getApiUrl } from '../config/environment';
import {
  clearAuthStorageAndRedirectToLogin,
  shouldClearSessionOn401,
} from '../utils/authSessionRedirect';

// Configuração base da API
const api = axios.create({
  baseURL: getApiUrl(),
  timeout: 30000, // 30 segundos - aumentado para evitar timeout em queries mais lentas
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação + contexto de unidade
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Anexar X-Unit-Id automaticamente quando houver unidade ativa. Sem isso, o
    // backend não consegue filtrar inboxes/conversas por unidade e o inbox
    // dinâmico pode exibir chats de outra unidade.
    if (!config.headers['X-Unit-Id']) {
      try {
        const rawUser = localStorage.getItem('auth_user');
        if (rawUser) {
          const parsed = JSON.parse(rawUser);
          const unitId = parsed?.current_unit?.id;
          if (unitId) config.headers['X-Unit-Id'] = unitId;
        }
      } catch (_e) {
        // ignore JSON parse errors
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (shouldClearSessionOn401(error)) {
      clearAuthStorageAndRedirectToLogin();
    }
    return Promise.reject(error);
  }
);

export { api }; 